import PropTypes from "prop-types"
import React, { Suspense } from "react"
import { Route, Routes } from "react-router-dom"
import { connect } from "react-redux"
import  "moment-timezone"
// Import Routes all
import { authRoutes, userRoutes } from "./routes/allRoutes"

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware"

// layouts Format
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
import "./index.css"
import "./custom.css"

import { MathJaxContext } from "better-react-mathjax"
import Loader from "react-spinner-loader"

const App = () => {

  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
  const config = {
    loader: { load: ["input/asciimath"] },
    asciimath: {
      displaystyle: true,
      delimiters: [
        ["`", "`"]
      ]
    }
  }

  const envClassName = process.env.REACT_APP_ENV

  return (
    <div id="env" className={envClassName}>
      <MathJaxContext config={config}>

        <Suspense fallback={<Loader type={'body'} show={true} />}>
          <Routes>
            <Route>
              {authRoutes.map((route, idx) => (
                <Route
                  path={route.path}
                  element={
                    <NonAuthLayout>
                      {route.component}
                    </NonAuthLayout>
                  }
                  key={idx}
                  exact={true}
                />
              ))}
            </Route>

            <Route>
              {userRoutes.map((route, idx) => (
                <Route
                  path={route.path}
                  element={
                    <Authmiddleware layout={route.layout}>
                      {route.component}
                    </Authmiddleware>}
                  key={idx}
                  exact={true}
                />
              ))}
            </Route>

          </Routes>
        </Suspense>
      </MathJaxContext>
    </div>
  )
}

App.propTypes = {
  layout: PropTypes.any
}

const mapStateToProps = state => {
  return {
    layout: state.Layout
  }
}

export default connect(mapStateToProps, null)(App)
